<script setup>
import { router, usePage } from '@inertiajs/vue3';
import { ref } from 'vue';
import Datepicker from '@vuepic/vue-datepicker';
import '@vuepic/vue-datepicker/dist/main.css';

// includes we need to front end locale magic
import { useI18n } from 'vue-i18n';

// Get the Programme, Organisation, and props we need to get the user preferred locale
const programme = router.page.props.ziggy.programme;
const organisation = router.page.props.ziggy.organisation;
const usePageProps = usePage().props;

// Get locale as set in cookie
const { locale, fallbackLocale} = useI18n({ useScope: 'global' });

// Set up all the data variables we are going to initially need
const props = defineProps({
    custom_question: Object,
    formData: Object,
    key: Number,
    datePicker: Object
});


const custom_question = props.custom_question;
const custom_question_key = custom_question.index_id;
const customRegFieldType = custom_question.type;

// If the field type is 'select', set up appropriate variables and build the array of options
// If the field type is 'select', set up appropriate variables and build the array of options
let selectListObject = '';
let selectListObjectKeys = [];
let selectList = [];
let selectOption = [];
let selectOptions = [];
if (customRegFieldType == 'select') {
    selectListObject = props.custom_question.select_options;

    if (selectListObject.constructor.name != 'Object') {
        selectListObject = JSON.parse(selectListObject);
    }

    selectListObjectKeys = Object.keys(selectListObject);

    if ( selectListObjectKeys.includes(locale.value) ) {
        selectList = selectListObject[locale.value];
    }
    else {
        selectList = selectListObject[fallbackLocale.value];
    }

    const selectOptionNames = selectList.split(",");
    const selectOptionValues = selectList.split(",");

    for (var i = 0; i < selectOptionNames.length; i++) {
        selectOption = {};
        selectOption.name = selectOptionNames[i].trim();
        selectOption.value = selectOptionValues[i].trim();
        selectOptions.push(selectOption);
    }
}

const dateOptions = { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' };
let date = ref(new Date());
if (customRegFieldType == 'date') {
    date = props.formData[custom_question_key].answer;
}
const format = (date) => {
        const day = date.getDate();
        const month = date.getMonth() + 1;
        const year = date.getFullYear();

        return `Selected date is ${day}/${month}/${year}`;
    }

const customRegFieldLabel = props.custom_question.label;
const customRegFieldDefaultValue = props.custom_question.default;
const customRegFieldID = props.custom_question.index_id;
const customRegFieldUniqueID = 'custom-user-question-' + customRegFieldID;

</script>

<template>

    <div class="mt-4">

        <label class="block mb-2" :for="customRegFieldUniqueID">
            <span>{{customRegFieldLabel[$i18n.locale] ? customRegFieldLabel[$i18n.locale] : customRegFieldLabel[$i18n.fallbackLocale]}} </span>
            <span v-if="custom_question.required == true" class="required-form-field">*</span>
        </label>

        <div v-if="customRegFieldType == 'text'" class="form-control">
            <input
            type="text"
            v-model="formData[custom_question_key].answer"
            :name="customRegFieldID"
            :id="customRegFieldUniqueID"
            :required="custom_question.required == true"
            class="w-full mb-5 mr-5 border-gray-300 rounded-md shadow-sm action-custom-field grow focus:border-indigo-300 focus:ring focus:ring-indigo-200 focus:ring-opacity-50"
            />
        </div>

        <div v-else-if="customRegFieldType == 'textarea'" class="form-control">
            <textarea
            v-model="formData[custom_question_key].answer"
            :name="customRegFieldUniqueID"
            :id="customRegFieldUniqueID"
            :required="custom_question.required == true"
            class="w-full mb-5 mr-5 border-gray-300 rounded-md shadow-sm action-custom-field grow focus:border-indigo-300 focus:ring focus:ring-indigo-200 focus:ring-opacity-50"
            ></textarea>
        </div>

        <div v-else-if="customRegFieldType == 'select'" class="form-control">
            <select
            v-if="selectOptions"
            v-model="formData[custom_question_key].answer"
            :name="customRegFieldUniqueID"
            :id="customRegFieldUniqueID"
            :required="custom_question.required == true"
            class="w-full mb-5 mr-5 border-gray-300 rounded-md shadow-sm action-custom-field grow focus:border-indigo-300 focus:ring focus:ring-indigo-200 focus:ring-opacity-50"
            >
            <option value="">{{ $t('teams.questions.option') }}</option>
            <option v-for="optionItem in selectOptions"
                :name="optionItem.name"
                :value="optionItem.value"
            >{{optionItem.name}}</option>
            </select>
        </div>

        <div v-else-if="customRegFieldType == 'checkbox'" class="form-control">
            <input
            type="checkbox"
            v-model="formData[custom_question_key].answer"
            :name="customRegFieldUniqueID"
            :id="customRegFieldUniqueID"
            :required="custom_question.required == true"
            class="mb-5 mr-5 border-gray-300 rounded-md shadow-sm action-custom-field focus:border-indigo-300 focus:ring focus:ring-indigo-200 focus:ring-opacity-50"
            />
        </div>

        <div v-else-if="customRegFieldType == 'date'" class="form-control">
            <div>
                <Datepicker
                v-model="formData[custom_question_key].answer"
                :format="format"
                :name="customRegFieldUniqueID"
                :id="customRegFieldUniqueID"
                :required="custom_question.required == true"
                />
            </div>

        </div>

    </div>

</template>
